/**
 * App.js - Main Application Entry Point
 * Now using React Router for navigation
 */

import React from 'react';
import AppRouter from './router/AppRouter';

function App() {
  return <AppRouter />;
}

export default App;
